import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";
import { Control } from "../control/control.model";
import { IJobPointer } from "../job/job.model";
import { VersionedObject } from "../versioned-object";

export interface IFieldArgs extends IAccountObjectArgs {
    control: string | Control;
    job: string;
    value?: string;
    version?: number;
    fieldJobPointers?: Array<IJobPointer>;
    dirty?: boolean;
}

const defaults = {
    control: "",
    job: "",
    value: undefined,
    version: 1,
    fieldJobPointers: [],
    dirty: false
} as IFieldArgs;

export class Field extends AccountObject implements VersionedObject {
    control: string | Control;
    job: string ;
    value: string;
    version: number;
    fieldJobPointers: Array<IJobPointer>;
    dirty: boolean;

    constructor(data?: IFieldArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/field/field.model.ts